import React, { Component } from "react";
export default class Resume extends Component {
  render() {
    let resumeData = this.props.resumeData;
    return (
      <section id="experience">
        <div className="row education">
          <div className="three columns header-col">
            <h1>
              <span>Education</span>
            </h1>
          </div>

          <div className="nine columns main-col">
            {resumeData.education &&
              resumeData.education.map((item, index) => {
                return (
                  <div key={"edu" + index} className="row item">
                    <div className="twelve columns">
                      <h3>{item.UniversityName}</h3>
                      <p className="info">
                        {item.specialization}
                        <span>&bull;</span>{" "}
                        <em className="date">
                          {item.MonthOfPassing} {item.YearOfPassing}
                        </em>
                      </p>
                      <p>{item.Achievements}</p>
                    </div>
                  </div>
                );
              })}
          </div>
        </div>
        <div className="row work">
          <div className="three columns header-col">
            <h1>
              <span>Work</span>
            </h1>
          </div>

          <div className="nine columns main-col">
            {resumeData.work &&
              resumeData.work.map((item, index) => {
                return (
                  <div
                    key={"exp" + index}
                    className="row item work-exp-padding"
                  >
                    <div className="twelve columns">
                      <h3>{item.CompanyName}</h3>
                      <p className="info">
                        {item.specialization}
                        <span>&bull;</span>{" "}
                        <em className="date">
                          {item.MonthOfLeaving} {item.YearOfLeaving}
                        </em>
                      </p>
                      {item.bulletSkills &&
                        item.bulletSkills.map((team, index) => {
                          return (
                            <div key={"team-info" + index}>
                              <h6>{team.bulletHeader}</h6>
                              <ul>
                                {team.skills &&
                                  team.skills.map((workBullet, index) => {
                                    return (
                                      <li key={"workBullet" + index}>
                                        {workBullet.name}
                                      </li>
                                    );
                                  })}
                              </ul>
                            </div>
                          );
                        })}
                    </div>
                  </div>
                );
              })}
          </div>
        </div>

        <div className="row skill">
          <div className="three columns header-col">
            <h1>
              <span>Skills</span>
            </h1>
          </div>

          <div className="nine columns main-col">
            <h2>Languages</h2>
            <ul className="social-links">
              {resumeData.skills.languages &&
                resumeData.skills.languages.map((item, index) => {
                  return <li key={"lang" + index}>{item.name}</li>;
                })}
            </ul>
            <h2>Frameworks</h2>
            <ul className="social-links">
              {resumeData.skills.frameworks &&
                resumeData.skills.frameworks.map((item, index) => {
                  return <li key={"frame" + index}>{item.name}</li>;
                })}
            </ul>
            <h2>Tools</h2>
            <ul className="social-links">
              {resumeData.skills.tools &&
                resumeData.skills.tools.map((item, index) => {
                  return <li key={"tool" + index}>{item.name}</li>;
                })}
            </ul>
          </div>
        </div>
      </section>
    );
  }
}
